import { render, staticRenderFns } from "./BuyerConfigurations.vue?vue&type=template&id=684e5751&"
import script from "./BuyerConfigurations.vue?vue&type=script&lang=js&"
export * from "./BuyerConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports